import "./index.css";

const quotationsArr = [
  "Be the change you wish to see.",
  "No act of kindness is ever wasted.",
  "Together, we can do so much",
  "Small acts, when multiplied, can change the world.",
  "Service to others is the rent we pay for living",
  "The power of one is infinite.",
  "Lift others, lift yourself.",
  "Kindness creates endless ripples",
];

const randomIndex = Math.floor(Math.random() * quotationsArr.length);

const Footer = () => {
  return (
    <div>
    <div className="footer-main-container">
      <div className="footer-sub-container">
        <div className="footer-section-first-container">
          <div className="logo-and-gmail-container">
            <img src="/Images/footerLogo.png" className="aswa-logo" />
            <div className="reach-us-container">
              <h5 className="reach-us">Reach us</h5>
              <a href="mailto:info@aswa4u.org">
                <div className="mail-container">
                  <img
                    className="locationImageFooter"
                    src="/Images/email.svg"
                  />
                  <p className="mail">info@aswa4u.org</p>
                </div>
              </a>
            </div>
          </div>
          <div className="address-container">
            <div className="address-heading-container">
              <img className="locationImageFooter" src="/Images/location.svg" />
              <p className="address-heading">Registered Office</p>
            </div>
            <p className="address-description">
              #13-104, P & T Colony,Gaddi Annaram,Dilsukh
              Nagar,Hyderabad-500060Telangana, India.
            </p>
          </div>
          <div className="address-container">
            <div className="address-heading-container">
              <img className="locationImageFooter" src="/Images/location.svg" />
              <p className="address-heading">ADMIN OFFICE</p>
            </div>
            <p className="address-description">
              #13-120, 2nd Floor,Christian Colony,Shadnagar, Ranga Reddy
              Dist.,Hyderabad - 509216.Telangana, India.
            </p>
          </div>
        </div>
        <div className="horizontal-line-container">{/* <hr /> */}</div>
        <div className="follow-us-section-container">
          <div className="follow-us-icons">
            <a href="https://www.facebook.com/AMMAASWA">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="locationImageFooter1"
              >
                <path
                  d="M19.9643 1.85718C21.1153 1.85718 22.0995 2.26585 22.9168 3.08318C23.7342 3.90052 24.1428 4.88471 24.1428 6.03575V19.9643C24.1428 21.1154 23.7342 22.0996 22.9168 22.9169C22.0995 23.7342 21.1153 24.1429 19.9643 24.1429H17.2366V15.5101H20.1239L20.5591 12.144H17.2366V9.99669C17.2366 9.45502 17.3502 9.04877 17.5775 8.77794C17.8048 8.5071 18.2474 8.37169 18.9051 8.37169L20.6752 8.35718V5.35383C20.0658 5.26678 19.205 5.22325 18.0926 5.22325C16.7771 5.22325 15.7252 5.61015 14.9369 6.38396C14.1486 7.15777 13.7544 8.25078 13.7544 9.66298V12.144H10.8527V15.5101H13.7544V24.1429H6.03569C4.88465 24.1429 3.90046 23.7342 3.08312 22.9169C2.26578 22.0996 1.85712 21.1154 1.85712 19.9643V6.03575C1.85712 4.88471 2.26578 3.90052 3.08312 3.08318C3.90046 2.26585 4.88465 1.85718 6.03569 1.85718H19.9643Z"
                  fill="white"
                />
              </svg>
            </a>
            <a href="https://www.instagram.com/ammaaswa/">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="locationImageFooter1"
              >
                <g clip-path="url(#clip0_1192_66)">
                  <path
                    d="M8.00065 12C8.00065 9.79095 9.79095 7.99968 12 7.99968C14.209 7.99968 16.0003 9.79095 16.0003 12C16.0003 14.209 14.209 16.0003 12 16.0003C9.79095 16.0003 8.00065 14.209 8.00065 12ZM5.83813 12C5.83813 15.4032 8.59677 18.1619 12 18.1619C15.4032 18.1619 18.1619 15.4032 18.1619 12C18.1619 8.59677 15.4032 5.83813 12 5.83813C8.59677 5.83813 5.83813 8.59677 5.83813 12ZM16.9658 5.59386C16.9658 6.38869 17.6103 7.03425 18.4061 7.03425C19.201 7.03425 19.8465 6.38869 19.8465 5.59386C19.8465 4.79903 19.2019 4.15444 18.4061 4.15444C17.6103 4.15444 16.9658 4.79903 16.9658 5.59386ZM7.15154 21.7677C5.98158 21.7144 5.34572 21.5195 4.9231 21.3548C4.36284 21.1367 3.96349 20.8769 3.54281 20.4572C3.1231 20.0375 2.86236 19.6381 2.64523 19.0779C2.48045 18.6553 2.28562 18.0194 2.23231 16.8494C2.17415 15.5845 2.16252 15.2045 2.16252 12C2.16252 8.79548 2.17512 8.41648 2.23231 7.15057C2.28562 5.98061 2.48142 5.34572 2.64523 4.92213C2.86333 4.36187 3.1231 3.96252 3.54281 3.54184C3.96252 3.12213 4.36187 2.86139 4.9231 2.64426C5.34572 2.47948 5.98158 2.28465 7.15154 2.23134C8.41648 2.17318 8.79645 2.16155 12 2.16155C15.2045 2.16155 15.5835 2.17415 16.8494 2.23134C18.0194 2.28465 18.6543 2.48045 19.0779 2.64426C19.6381 2.86139 20.0375 3.12213 20.4582 3.54184C20.8779 3.96155 21.1376 4.36187 21.3557 4.92213C21.5205 5.34475 21.7153 5.98061 21.7687 7.15057C21.8268 8.41648 21.8384 8.79548 21.8384 12C21.8384 15.2036 21.8268 15.5835 21.7687 16.8494C21.7153 18.0194 21.5195 18.6553 21.3557 19.0779C21.1376 19.6381 20.8779 20.0375 20.4582 20.4572C20.0385 20.8769 19.6381 21.1367 19.0779 21.3548C18.6553 21.5195 18.0194 21.7144 16.8494 21.7677C15.5845 21.8258 15.2045 21.8375 12 21.8375C8.79645 21.8375 8.41648 21.8258 7.15154 21.7677ZM7.05267 0.0726979C5.77512 0.130856 4.90275 0.333441 4.1399 0.630048C3.35089 0.936349 2.68207 1.34733 2.01422 2.01422C1.34733 2.6811 0.936349 3.34992 0.630048 4.1399C0.333441 4.90275 0.130856 5.77512 0.0726979 7.05267C0.0135703 8.33215 0 8.7412 0 12C0 15.2588 0.0135703 15.6679 0.0726979 16.9473C0.130856 18.2249 0.333441 19.0973 0.630048 19.8601C0.936349 20.6491 1.34637 21.3189 2.01422 21.9858C2.6811 22.6527 3.34992 23.0627 4.1399 23.37C4.90372 23.6666 5.77512 23.8691 7.05267 23.9273C8.33312 23.9855 8.7412 24 12 24C15.2598 24 15.6679 23.9864 16.9473 23.9273C18.2249 23.8691 19.0973 23.6666 19.8601 23.37C20.6491 23.0627 21.3179 22.6527 21.9858 21.9858C22.6527 21.3189 23.0627 20.6491 23.37 19.8601C23.6666 19.0973 23.8701 18.2249 23.9273 16.9473C23.9855 15.6669 23.999 15.2588 23.999 12C23.999 8.7412 23.9855 8.33215 23.9273 7.05267C23.8691 5.77512 23.6666 4.90275 23.37 4.1399C23.0627 3.35089 22.6527 2.68207 21.9858 2.01422C21.3189 1.34733 20.6491 0.936349 19.8611 0.630048C19.0973 0.333441 18.2249 0.129887 16.9483 0.0726979C15.6688 0.0145396 15.2598 0 12.001 0C8.7412 0 8.33312 0.0135703 7.05267 0.0726979Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1192_66">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a href="https://twitter.com/ammaaswa">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="locationImageFooter1"
              >
                <path
                  d="M14.1667 10.4L22 2H20L13.2667 9.2L8.00001 2H1.33334L9.53334 13.2L1.33334 22H3.33334L10.4333 14.4L16 22H22.6667L14.1667 10.4ZM4.30001 3.33333H6.96668L19.6667 20.6667H17L4.30001 3.33333Z"
                  fill="white"
                />
              </svg>
            </a>
            <a href="https://api.whatsapp.com/send/?phone=919948885111&text&type=phone_number&app_absent=0">
              {" "}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="locationImageFooter1"
              >
                <g clip-path="url(#clip0_536_691)">
                  <path
                    d="M17.6025 14.412C17.3614 14.2921 15.794 13.573 15.5529 13.4532C15.3117 13.3333 15.0706 13.3333 14.8295 13.573C14.5884 13.8127 14.1061 14.5318 13.865 14.7715C13.7444 15.0112 13.5033 15.0112 13.2621 14.8914C12.4182 14.5318 11.5742 14.0524 10.8508 13.4532C10.248 12.8539 9.6452 12.1348 9.16294 11.4157C9.04237 11.176 9.16293 10.9363 9.2835 10.8165C9.40406 10.6966 9.52463 10.4569 9.76576 10.3371C9.88632 10.2172 10.0069 9.97753 10.0069 9.85768C10.1275 9.73783 10.1275 9.49813 10.0069 9.37828C9.88632 9.25843 9.2835 7.82022 9.04237 7.22097C8.92181 6.38202 8.68067 6.38202 8.43954 6.38202H7.83672C7.59559 6.38202 7.2339 6.62172 7.11333 6.74157C6.38994 7.46067 6.02825 8.29963 6.02825 9.25843C6.14881 10.3371 6.51051 11.4157 7.2339 12.3745C8.56011 14.2921 10.248 15.8502 12.2976 16.809C12.9004 17.0487 13.3827 17.2884 13.9855 17.4082C14.5884 17.6479 15.1912 17.6479 15.9146 17.5281C16.7585 17.4082 17.4819 16.809 17.9642 16.0899C18.2053 15.6105 18.2053 15.1311 18.0847 14.6517L17.6025 14.412ZM20.6166 3.50562C15.9146 -1.16854 8.31898 -1.16854 3.61695 3.50562C-0.24113 7.34082 -0.964519 13.2135 1.68791 17.8876L0 24L6.38994 22.3221C8.19841 23.2809 10.1275 23.7603 12.0565 23.7603C18.6876 23.7603 23.9924 18.4869 23.9924 11.8951C24.113 8.77903 22.7868 5.78277 20.6166 3.50562ZM17.3613 20.2846C15.794 21.2434 13.9855 21.8427 12.0565 21.8427C10.248 21.8427 8.56011 21.3633 6.99277 20.5243L6.63107 20.2846L2.89356 21.2434L3.85808 17.6479L3.61695 17.2884C0.723389 12.4944 2.17017 6.50187 6.8722 3.50562C11.5742 0.509363 17.6025 2.06742 20.496 6.62172C23.3896 11.2959 22.0634 17.4082 17.3613 20.2846Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_536_691">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a href="https://www.youtube.com/channel/UCi3-LOqxkkyrIAxKv8WtGoA">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="locationImageFooter1"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.98 6.09C22.329 4.932 21.6225 4.719 20.184 4.638C18.747 4.5405 15.1335 4.5 12.003 4.5C8.8665 4.5 5.2515 4.5405 3.816 4.6365C2.3805 4.719 1.6725 4.9305 1.0155 6.09C0.345 7.2465 0 9.2385 0 12.7455V12.7575C0 16.2495 0.345 18.2565 1.0155 19.401C1.6725 20.559 2.379 20.769 3.8145 20.8665C5.2515 20.9505 8.8665 21 12.003 21C15.1335 21 18.747 20.9505 20.1855 20.868C21.624 20.7705 22.3305 20.5605 22.9815 19.4025C23.658 18.258 24 16.251 24 12.759V12.747C24 9.2385 23.658 7.2465 22.98 6.09ZM9 17.25V8.25L16.5 12.75L9 17.25Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
          <div>
            <p className="quotation">{quotationsArr[randomIndex]}</p>
          </div>
        </div>
      </div>
    </div>
    <p className="copyright">
          {" "}
          © 2024 ASWA - Amma Social Welfare Assosication. All rights reserved.{" "}
        </p>                
    </div>
  );
};

export default Footer;
